import { call, put, takeLatest, all, take } from "redux-saga/effects";

import {
  ACTION_GET_REQUESTING,
  ACTION_GET_SUCCESS,
  ACTION_GET_ERROR,
  ACTION_GET_ALL_LIST_REQUESTING,
  ACTION_GET_ALL_LIST_SUCCESS,
  ACTION_GET_ALL_LIST_ERROR,
  ACTION_GET_SELECTION_LIST_REQUESTING,
  ACTION_GET_SELECTION_LIST_SUCCESS,
  ACTION_GET_SELECTION_LIST_ERROR,
  ACTION_UPDATE_SELECTION_SUCCESS,
  ACTION_UPDATE_SELECTION_ERROR,
  ACTION_UPDATE_SELECTION_REQUESTING,
  ACTION_CREATE_REQUESTING,
  ACTION_CREATE_ERROR,
  ACTION_CREATE_SUCCESS,
  ACTION_DELETE_PRIVATE_REQUESTING,
  ACTION_MODIFY_PRIVATE_REQUESTING,
  ACTION_GET_PRIVATE_REQUESTING,
  ACTION_GET_PRIVATE_ERROR,
  ACTION_GET_PRIVATE_SUCCESS,
  ACTION_GET_SELECTED_REQUESTING,
  ACTION_GET_SELECTED_SUCCESS,
  ACTION_GET_SELECTED_ERROR,
  ACTION_DELETE_PRIVATE_SUCCESS,
  ACTION_DELETE_PRIVATE_ERROR,
  ACTION_MODIFY_PRIVATE_SUCCESS,
  ACTION_MODIFY_PRIVATE_ERROR
} from "./constants";

import { fetchApi } from "../api";

const apiEndpoints = {
  getList: "/v1/actions/get-info-all",
  getAction: "/v1/actions/get-quickly/",
  getAllActionsList: "/v1/actions/get-all-quickly/",
  getSelectionList: "/v1/clients/get-actions-selected-id",
  updateActionsSelected: "/v1/clients/update-actions-selected",
  createPrivateAction: "/v1/clients/create-private-action",
  deletePrivateAction: "/v1/clients/delete-private-action",
  modifyAction: "/v1/actions/update",
  getPrivateActions: "/v1/clients/get-private-actions",
  getSelectedActions: "/v1/clients/get-actions-selected"
};

const getListApi = data => {
  return fetchApi(apiEndpoints.getList, data, "post");
};

const getActionApi = data => {
  return fetchApi(apiEndpoints.getAction + data, {}, "get");
};

const getAllActionsListApi = () => {
  return fetchApi(apiEndpoints.getAllActionsList, {}, "post");
};

const getSelectionListApi = data => {
  return fetchApi(apiEndpoints.getSelectionList, data, "post");
};

const updateActionsSelectedApi = data => {
  return fetchApi(apiEndpoints.updateActionsSelected, data, "post");
};

const createPrivateActionApi = data => {
  return fetchApi(apiEndpoints.createPrivateAction, data, "post");
};

const deletePrivateActionApi = data => {
  return fetchApi(apiEndpoints.deletePrivateAction, data, "post");
};

const modifyActionApi = data => {
  return fetchApi(apiEndpoints.modifyAction, data, "patch");
};

const getPrivateActionsApi = data => {
  return fetchApi(apiEndpoints.getPrivateActions, data, "post");
};

const getSelectedActionsApi = data => {
  return fetchApi(apiEndpoints.getSelectedActions, data, "post");
};

function* getActionSaga(actionId) {
  try {
    const action = yield call(getActionApi, actionId);
    yield put({ type: ACTION_GET_SUCCESS, payload: action });
  } catch (error) {
    let message;
    switch (error.status) {
      case 500:
        message = "Internal Server Error";
        break;
      case 401:
        message = "Invalid credentials";
        break;
      default:
        message = "Something went wrong";
    }
    yield put({ type: ACTION_GET_ERROR, payload: message });
  }
}

function* getAllActionsListSaga() {
  try {
    const action = yield call(getAllActionsListApi);
    yield put({ type: ACTION_GET_ALL_LIST_SUCCESS, payload: action });
  } catch (error) {
    let message;
    switch (error.status) {
      case 500:
        message = "Internal Server Error";
        break;
      case 401:
        message = "Invalid credentials";
        break;
      default:
        message = "Something went wrong";
    }
    yield put({ type: ACTION_GET_ALL_LIST_ERROR, payload: message });
  }
}

function* getSelectionListSaga(action) {
  try {
    const selection = yield call(getSelectionListApi, action.payload);
    yield put({ type: ACTION_GET_SELECTION_LIST_SUCCESS, payload: selection });
  } catch (error) {
    let message;
    switch (error.status) {
      case 500:
        message = "Internal Server Error";
        break;
      case 401:
        message = "Invalid credentials";
        break;
      default:
        message = "Something went wrong";
    }
    yield put({ type: ACTION_GET_SELECTION_LIST_ERROR, payload: message });
  }
}

function* updateActionsSelectedSaga(action) {
  try {
    const selection = yield call(updateActionsSelectedApi, action.payload);
    yield put({ type: ACTION_UPDATE_SELECTION_SUCCESS, payload: selection });
  } catch (error) {
    let message;
    switch (error.status) {
      case 500:
        message = "Internal Server Error";
        break;
      case 401:
        message = "Invalid credentials";
        break;
      default:
        message = "Something went wrong";
    }
    yield put({ type: ACTION_UPDATE_SELECTION_ERROR, payload: message });
  }
}

function* createActionSaga(action) {
  try {
    const result = yield call(createPrivateActionApi, action.payload);
    yield put({ type: ACTION_CREATE_SUCCESS, payload: result });
  } catch (error) {
    console.log(error);
    yield put({ type: ACTION_CREATE_ERROR, payload: error });
  }
}

function* getBestActionsSaga(action) {
  try {
    const promises = yield all(
      Object.keys(action.payload).map((el, i) => {
        return getActionSaga(action.payload[el].action);
      })
    );
  } catch (error) {
    console.log(error);
  }
}

function* getPrivateActionsSaga(action) {
  try {
    const result = yield call(getPrivateActionsApi, action.payload);
    yield put({ type: ACTION_GET_PRIVATE_SUCCESS, payload: result });
  } catch (error) {
    console.log(error);
    yield put({ type: ACTION_GET_PRIVATE_ERROR, payload: error });
  }
}

function* getSelectedActionsSaga(action) {
  try {
    const result = yield call(getSelectedActionsApi, action.payload);
    yield put({ type: ACTION_GET_SELECTED_SUCCESS, payload: result });
  } catch (error) {
    console.log(error);
    yield put({ type: ACTION_GET_SELECTED_ERROR, payload: error });
  }
}

function* deleteActionSaga(action) {
  try {
    const result = yield call(deletePrivateActionApi, action.payload);
    yield put({ type: ACTION_DELETE_PRIVATE_SUCCESS, payload: action.payload });
  } catch (error) {
    console.log(error);
    yield put({ type: ACTION_DELETE_PRIVATE_ERROR, payload: error });
  }
}

function* modifyActionSaga(action) {
  try {
    const result = yield call(modifyActionApi, action.payload);
    yield put({ type: ACTION_MODIFY_PRIVATE_SUCCESS, payload: result });
  } catch (error) {
    yield put({ type: ACTION_MODIFY_PRIVATE_ERROR, payload: action.payload });
    console.log(error);
  }
}

function* Saga() {
  yield all([
    takeLatest(ACTION_GET_REQUESTING, getBestActionsSaga),
    takeLatest(ACTION_GET_ALL_LIST_REQUESTING, getAllActionsListSaga),
    takeLatest(ACTION_GET_SELECTION_LIST_REQUESTING, getSelectionListSaga),
    takeLatest(ACTION_UPDATE_SELECTION_REQUESTING, updateActionsSelectedSaga),
    takeLatest(ACTION_CREATE_REQUESTING, createActionSaga),
    takeLatest(ACTION_DELETE_PRIVATE_REQUESTING, deleteActionSaga),
    takeLatest(ACTION_MODIFY_PRIVATE_REQUESTING, modifyActionSaga),
    takeLatest(ACTION_GET_PRIVATE_REQUESTING, getPrivateActionsSaga),
    takeLatest(ACTION_GET_SELECTED_REQUESTING, getSelectedActionsSaga),
    takeLatest(ACTION_DELETE_PRIVATE_REQUESTING, deleteActionSaga)
  ]);
}

export default Saga;
